"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userActionFetch = exports.simpleFetch = void 0;
const cross_fetch_1 = require("cross-fetch");
const dfnsError_1 = require("../dfnsError");
const baseAuthApi_1 = require("../baseAuthApi");
const nonce_1 = require("./nonce");
const fullUrl = (fetch) => {
    return async (resource, options) => {
        const { baseUrl } = options.apiOptions;
        resource = new URL(resource, baseUrl);
        return fetch(resource, options);
    };
};
const jsonSerializer = (fetch) => {
    return async (resource, options) => {
        if (options.body) {
            options.body = JSON.stringify(options.body);
            options.headers = {
                'content-type': 'application/json',
                ...(options.headers ?? {}),
            };
        }
        return fetch(resource, options);
    };
};
const errorHandler = (fetch) => {
    return async (resource, options) => {
        const response = await fetch(resource, options);
        if (response.ok) {
            return response;
        }
        else {
            const body = await response.json();
            const message = body?.error?.message ?? body?.message;
            throw new dfnsError_1.DfnsError(response.status, message, {
                url: response.url,
                headers: response.headers,
                body,
            });
        }
    };
};
const dfnsAuth = (fetch) => {
    return async (resource, options) => {
        const { appId, appSecret, authToken } = options.apiOptions;
        const authorization = authToken
            ? {
                authorization: `Bearer ${authToken}`,
            }
            : {};
        const dfnsAppSecret = appSecret
            ? {
                'x-dfns-appsecret': appSecret,
            }
            : {};
        options.headers = {
            'x-dfns-appid': appId,
            'x-dfns-nonce': (0, nonce_1.generateNonce)(),
            ...dfnsAppSecret,
            ...authorization,
            ...(options.headers ?? {}),
        };
        return fetch(resource, options);
    };
};
const userAction = (fetch) => {
    return async (resource, options) => {
        if (options.method !== 'GET') {
            const apiOptions = {
                ...options.apiOptions,
                baseUrl: options.apiOptions.baseAuthUrl || options.apiOptions.baseUrl,
            };
            const { challenge, challengeIdentifier, allowCredentials } = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
                userActionPayload: options.body ?? '',
                userActionHttpMethod: options.method,
                userActionHttpPath: resource.pathname,
                userActionServerKind: apiOptions?.userActionServerKind || 'Api',
            }, apiOptions);
            const assertion = await apiOptions.signer.sign(challenge, allowCredentials);
            const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge({
                challengeIdentifier,
                firstFactor: assertion,
            }, apiOptions);
            options.headers = {
                'x-dfns-useraction': userAction,
                ...(options.headers ?? {}),
            };
        }
        return fetch(resource, options);
    };
};
exports.simpleFetch = fullUrl(jsonSerializer(dfnsAuth(errorHandler(cross_fetch_1.fetch))));
exports.userActionFetch = fullUrl(jsonSerializer(dfnsAuth(userAction(errorHandler(cross_fetch_1.fetch)))));
